module.exports = __webpack_public_path__ + "img/shield.61c320ac.svg";